import Rupees, { rupees } from '@instamojo/rupee';
import React from 'react';

export interface RupeeProps {
  value?: string;
}

const Rupee: React.FC<RupeeProps> = ({ value }) => {
  return (
    <div className="flex justify-end">
      <div>
        <Rupees />
        {rupees(value)}
      </div>
    </div>
  );
};

export default Rupee;
